import styled from 'styled-components';

export const MainMultiDisplayContainer = styled.div`
    // text-shadow: black 0px 0px 5px;
    width: 100%;
    // height: auto;
    margin: 2% 0 2% 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    

    .main-multi-box {
        width: 98%;
        display: flex;
        // justify-content: center;
        flex-wrap: wrap;

        .display {
            text-decoration: inherit;
            width: ${window.screen.width <= 1000 ? '98%' : '23%'}; 
            height: auto;
            margin: ${window.screen.width <= 1000 ? '3%' : '1%'};  
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 7px;
            box-shadow: 3px 3px 3px rgba(255,255,255,0.3);
            // overflow: hidden;

            .banner {
                width: 100%;
                height: auto;
                min-height: 20vh;
                overflow: hidden;
            }

            .display-info {
                margin: 0;
                padding: 0;

                h2 {
                    font-size: ${window.screen.width <= 1000 ? '16px' : '20px'}; 
                    margin: 0;
                }
                
                p {
                    // font-size: ${window.screen.width <= 1000 ? '16px' : '20px'}; 
                    margin-top: 0.2em;
                }
            }

            .card-button-box {
                width: 100%;
                display: flex;
                flex-direction: ${window.screen.width <= 1000 ? 'column' : 'row'};
                justify-content: space-between;
                align-items: center;

                button {
                    font-size: 1em;
                    color: white;
                    padding: 1em;
                    max-width: ${window.screen.width <= 1000 ? '100%' : 'auto'};
                }
            }

        }

        .float-button {
            background-color: rgba(0,0,0,0.4);
            // width: 100vw;
            // height: 30%;
            display: flex;
            align-items: center;
            position: fixed;
            right: 5%;
            bottom: 20%;
        }
    }

    
    
`;